import ControlledTable, { ITableRowData } from "@/manager/components/controlled-table/controlled-table";
import { IColumn, ISortedBy } from "../../../components/data-table/data-table";
import { useContext, useEffect, useState } from "react";
import { noop } from "@/manager/utils";
import AuthContext from "@/shared/context/auth-context";
import useHttp from "@/shared/hooks/use-http";
import { getAllData } from "@/shared/utils/api";

const historyColumns: IColumn[] = [{
  key: "date",
  displayName: "Date",
  dataType: {
    type: "dateTime"
  }
}, {
  key: "user_name",
  displayName: "User",
  sortable: false,
  dataType: {
    type: "text"
  }
}, {
  key: "action",
  displayName: "Performed action",
  dataType: {
    type: "text"
  }
}];

interface IHistoryProps {
  alertcaseId: string;
}

const History = ({alertcaseId}: IHistoryProps) => {
  const authCtx = useContext(AuthContext);

  const [data, setData] = useState<ITableRowData[]>([]);
  const [sortedByCol, setSortedByCol] = useState<ISortedBy>({column: "date", direction: "desc"});  
  
  const { sendRequest: getTableData, status: getTableDataStatus, data: getTableDataResult, error: getTableDataError } = useHttp(getAllData, true, authCtx.token, "history", "manager");

  useEffect(() => {
    if (!alertcaseId) {
      return;
    }
    getTableData(`audit_trails/${alertcaseId}?order_by=${sortedByCol.column} ${sortedByCol.direction}`);
  }, [sortedByCol, alertcaseId]);

  useEffect(() => {
    if (getTableDataStatus === "completed" && !getTableDataError && getTableDataResult) {
      setData(getTableDataResult);
    }
  }, [getTableDataResult, getTableDataError, getTableDataStatus]);

  return <div className="history">
    <ControlledTable readOnly={true} data={data} onDeleted={noop} onSorted={setSortedByCol} onNewClicked={noop} onRowClick={noop} onScroll={noop} selectionMode="off" columns={historyColumns} />
  </div>;
};

export default History;